import { CatalogMode, getWithAuthn } from "../../RequestHelpers";
export var deserializeUserCatalog = function (jsonCatalog) {
    var probeSet = deserializeProbeSetCatalog(jsonCatalog.probeSet);
    var cishAmplifier = deserializeUserAmplifierCatalog(jsonCatalog.proDetect);
    var legacyFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.legacyFishAmplifier);
    var goldFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.goldFishAmplifier);
    var encoderAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.encoderAmplifier);
    var legacyFishBuffer = deserializeFishBufferCatalog(jsonCatalog.legacyFishBuffer);
    var goldFishBuffer = deserializeFishBufferCatalog(jsonCatalog.goldFishBuffer);
    var proPlatforms = jsonCatalog.proPlatforms;
    var proChromogens = deserializeChromogenCatalog(jsonCatalog.proChromogens);
    var manualProBuffer = deserializeManualProBufferCatalog(jsonCatalog.manualProBuffer);
    return {
        proPlatforms: proPlatforms,
        proChromogens: proChromogens,
        probeSet: probeSet,
        presetScales: jsonCatalog.presetScales,
        automatedProScaleOptions: jsonCatalog.automatedProScaleOptions,
        defaultAutomatedProScale: jsonCatalog.defaultAutomatedProScale,
        manualProScaleOptions: jsonCatalog.manualProScaleOptions,
        defaultManualProScale: jsonCatalog.defaultManualProScale,
        proAmplifier: cishAmplifier,
        legacyFishAmplifier: legacyFishAmplifier,
        goldFishAmplifier: goldFishAmplifier,
        encoderAmplifier: encoderAmplifier,
        goldFishBuffer: goldFishBuffer,
        legacyFishBuffer: legacyFishBuffer,
        manualProBuffer: manualProBuffer
    };
};
export var deserializeAdminCatalog = function (jsonCatalog) {
    var probeSet = deserializeProbeSetCatalog(jsonCatalog.probeSet);
    var cishAmplifier = deserializeAdminAmplifierCatalog(jsonCatalog.proDetect);
    var legacyFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.legacyFishAmplifier);
    var goldFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.goldFishAmplifier);
    var encoderAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.encoderAmplifier);
    var legacyFishBuffer = deserializeFishBufferCatalog(jsonCatalog.legacyFishBuffer);
    var goldFishBuffer = deserializeFishBufferCatalog(jsonCatalog.goldFishBuffer);
    var proPlatforms = jsonCatalog.proPlatforms;
    var proChromogens = deserializeChromogenCatalog(jsonCatalog.proChromogens);
    var manualProBuffer = deserializeManualProBufferCatalog(jsonCatalog.manualProBuffer);
    return {
        proPlatforms: proPlatforms,
        proChromogens: proChromogens,
        probeSet: probeSet,
        presetScales: jsonCatalog.presetScales,
        automatedProScaleOptions: jsonCatalog.automatedProScaleOptions,
        defaultAutomatedProScale: jsonCatalog.defaultAutomatedProScale,
        manualProScaleOptions: jsonCatalog.manualProScaleOptions,
        defaultManualProScale: jsonCatalog.defaultManualProScale,
        proAmplifier: cishAmplifier,
        legacyFishAmplifier: legacyFishAmplifier,
        goldFishAmplifier: goldFishAmplifier,
        encoderAmplifier: encoderAmplifier,
        goldFishBuffer: goldFishBuffer,
        legacyFishBuffer: legacyFishBuffer,
        manualProBuffer: manualProBuffer
    };
};
export var deserializeProbeSetCatalog = function (jsonProbeSetCatalog) {
    var probeSet = {
        catalog: {
            organisms: jsonProbeSetCatalog.catalog.organisms.map(function (o) { return new LibraryOrganism(o.id, o.name, o.scientificName, function (libOrg) {
                return o.probeSetFamilies.map(function (jsonFamily) {
                    return new ProbeSetFamily(jsonFamily.id, jsonFamily.geneSymbol, jsonFamily.description, jsonFamily.geneType, jsonFamily.accessions, jsonFamily.synonyms, function (psf) {
                        return jsonFamily.variants.map(function (v) {
                            return {
                                id: v.id,
                                organism: libOrg,
                                probeSetFamily: psf,
                                name: v.name,
                                designNumber: v.designNumber,
                                targetMrnaSeq: v.targetMrnaSeq,
                                bindingSites: v.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                accession: v.accession ? new Accession(v.accession.id, v.accession.transcriptAccession, v.accession.accessionType, v.accession.transcriptLength, v.accession.transcriptName) : undefined,
                                probeSetSize: v.probeSetSize,
                                validated: v.validated,
                                dcvScore: v.dcvScore,
                                designType: v.designType
                            };
                        });
                    }, function (psf) {
                        return {
                            id: jsonFamily.defaultVariant.id,
                            organism: libOrg,
                            probeSetFamily: psf,
                            name: jsonFamily.defaultVariant.name,
                            designNumber: jsonFamily.defaultVariant.designNumber,
                            targetMrnaSeq: jsonFamily.defaultVariant.targetMrnaSeq,
                            bindingSites: jsonFamily.defaultVariant.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                            accession: jsonFamily.defaultVariant.accession ? new Accession(jsonFamily.defaultVariant.accession.id, jsonFamily.defaultVariant.accession.transcriptAccession, jsonFamily.defaultVariant.accession.accessionType, jsonFamily.defaultVariant.accession.transcriptLength, jsonFamily.defaultVariant.accession.transcriptName) : undefined,
                            probeSetSize: jsonFamily.defaultVariant.probeSetSize,
                            validated: jsonFamily.defaultVariant.validated,
                            dcvScore: jsonFamily.defaultVariant.dcvScore,
                            designType: jsonFamily.defaultVariant.designType
                        };
                    });
                });
            }, o.taxonomyId); }),
            fishScales: jsonProbeSetCatalog.catalog.fishScales.map(function (s) { return new Scale(s); }),
            fishDefaultScale: new Scale(jsonProbeSetCatalog.catalog.fishDefaultScale)
        },
        custom: {
            probeSetSizes: jsonProbeSetCatalog.custom.probeSetSizes,
            fishScales: jsonProbeSetCatalog.custom.fishScales.map(function (s) { return new Scale(s); }),
            fishDefaultScale: new Scale(jsonProbeSetCatalog.custom.fishDefaultScale)
        }
    };
    return probeSet;
};
export var deserializeAdminAmplifierCatalog = function (jsonAmpCatalog) {
    return {
        userConfigs: {
            oneTargetProAmps: deserializeProAmpCatalog(jsonAmpCatalog.userConfigs.oneTargetProAmps),
            twoTargetProAmps: deserializeProAmpCatalog(jsonAmpCatalog.userConfigs.twoTargetProAmps),
            manualProAmps: deserializeProAmpCatalog(jsonAmpCatalog.userConfigs.manualProAmps)
        },
        hcrAmplifiers: jsonAmpCatalog.hcrAmplifiers.map(function (h) { return new HcrAmplifier(h.id); }),
        defaultHcrAmplifier: new HcrAmplifier(jsonAmpCatalog.defaultHcrAmplifier.id),
        hapten: jsonAmpCatalog.hapten.map(function (h) { return new Hapten(h); }),
        defaultHapten: new Hapten(jsonAmpCatalog.defaultHapten),
        enzymes: jsonAmpCatalog.enzyme,
        defaultEnzyme: jsonAmpCatalog.defaultEnzyme,
    };
};
export var deserializeUserAmplifierCatalog = function (jsonAmpCatalog) {
    return {
        oneTargetProAmps: deserializeProAmpCatalog(jsonAmpCatalog.oneTargetProAmps),
        twoTargetProAmps: deserializeProAmpCatalog(jsonAmpCatalog.twoTargetProAmps),
        manualProAmps: deserializeProAmpCatalog(jsonAmpCatalog.manualProAmps)
    };
};
export var deserializeProAmpCatalog = function (jsonAmpCatalog) {
    var amplifier = {
        proAmpConfigList: jsonAmpCatalog.proAmpConfigList.map(function (j) {
            return new ProAmplifierConfig(j.id, j.label, j.platformCompatibility, j.channelNum, new HcrAmplifier(j.amplifier.id), new Hapten(j.hapten), j.enzyme, j.isDefault);
        }),
    };
    return amplifier;
};
export var deserializeFishAmplifierCatalog = function (jsonAmpCatalog) {
    var amplifier = {
        channels: jsonAmpCatalog.channels.map(function (c) {
            return {
                hcrAmplifier: new HcrAmplifier(c.hcrAmplifier.id),
                labels: new PredefinedLabels(c.labels.standard.map(function (s) {
                    return {
                        label: new PredefinedLabel(s.label.id, s.label.name, s.label.isStandard),
                        scales: s.scalePmols.map(function (scale) {
                            return new Pmol(scale);
                        }),
                        defaultScale: new Pmol(s.defaultScalePmol)
                    };
                }), c.labels.extended.map(function (e) {
                    return {
                        label: new PredefinedLabel(e.label.id, e.label.name, e.label.isStandard),
                        scales: e.scalePmols.map(function (scale) {
                            return new Pmol(scale);
                        }),
                        defaultScale: new Pmol(e.defaultScalePmol)
                    };
                }), c.labels.admin.map(function (e) {
                    return {
                        label: new PredefinedLabel(e.label.id, e.label.name, e.label.isStandard),
                        scales: e.scalePmols.map(function (scale) {
                            return new Pmol(scale);
                        }),
                        defaultScale: new Pmol(e.defaultScalePmol)
                    };
                })),
                defaultLabel: {
                    label: new PredefinedLabel(c.defaultLabel.label.id, c.defaultLabel.label.name, c.defaultLabel.label.isStandard),
                    scales: c.defaultLabel.scalePmols.map(function (s) {
                        return new Pmol(s);
                    }),
                    defaultScale: new Pmol(c.defaultLabel.defaultScalePmol)
                },
                forwardCompatibility: c.forwardCompatibility.map(function (fc) {
                    return new PredefinedLabel(fc.id, fc.name, fc.isStandard);
                }),
                admin: c.admin
            };
        }),
        defaultChannel: {
            hcrAmplifier: new HcrAmplifier(jsonAmpCatalog.defaultChannel.hcrAmplifier.id),
            labels: new PredefinedLabels(jsonAmpCatalog.defaultChannel.labels.standard.map(function (s) {
                return {
                    label: new PredefinedLabel(s.label.id, s.label.name, s.label.isStandard),
                    scales: s.scalePmols.map(function (scale) {
                        return new Pmol(scale);
                    }),
                    defaultScale: new Pmol(s.defaultScalePmol)
                };
            }), jsonAmpCatalog.defaultChannel.labels.extended.map(function (e) {
                return {
                    label: new PredefinedLabel(e.label.id, e.label.name, e.label.isStandard),
                    scales: e.scalePmols.map(function (scale) {
                        return new Pmol(scale);
                    }),
                    defaultScale: new Pmol(e.defaultScalePmol)
                };
            }), jsonAmpCatalog.defaultChannel.labels.admin.map(function (e) {
                return {
                    label: new PredefinedLabel(e.label.id, e.label.name, e.label.isStandard),
                    scales: e.scalePmols.map(function (scale) {
                        return new Pmol(scale);
                    }),
                    defaultScale: new Pmol(e.defaultScalePmol)
                };
            })),
            defaultLabel: {
                label: new PredefinedLabel(jsonAmpCatalog.defaultChannel.defaultLabel.label.id, jsonAmpCatalog.defaultChannel.defaultLabel.label.name, jsonAmpCatalog.defaultChannel.defaultLabel.label.isStandard),
                scales: jsonAmpCatalog.defaultChannel.defaultLabel.scalePmols.map(function (s) {
                    return new Pmol(s);
                }),
                defaultScale: new Pmol(jsonAmpCatalog.defaultChannel.defaultLabel.defaultScalePmol)
            },
            forwardCompatibility: jsonAmpCatalog.defaultChannel.forwardCompatibility.map(function (fc) {
                return new PredefinedLabel(fc.id, fc.name, fc.isStandard);
            }),
            admin: jsonAmpCatalog.defaultChannel.admin
        },
        freeTextLabelScales: jsonAmpCatalog.freeTextLabelScalePmols.map(function (p) { return new Pmol(p); })
    };
    return amplifier;
};
export var deserializeFishBufferCatalog = function (jsonBuffCatalog) {
    if (isLegacyBufferCatalog(jsonBuffCatalog)) {
        return new LegacyFishBufferCatalog(jsonBuffCatalog.sampleTypes, jsonBuffCatalog.defaultSampleType, extractBufferMetadata(jsonBuffCatalog.probeWash), extractBufferMetadata(jsonBuffCatalog.amplifier), extractBufferMetadata(jsonBuffCatalog.hybridization));
    }
    else {
        var goldAmpWash = extractBufferMetadata(jsonBuffCatalog.goldAmpWash);
        var proAmpWash = extractBufferMetadata(jsonBuffCatalog.proAmpWash);
        return new GoldFishBufferCatalog(jsonBuffCatalog.sampleTypes, jsonBuffCatalog.defaultSampleType, extractBufferMetadata(jsonBuffCatalog.probeWash), extractBufferMetadata(jsonBuffCatalog.amplifier), extractBufferMetadata(jsonBuffCatalog.hybridization), goldAmpWash, proAmpWash);
    }
};
export var deserializeChromogenCatalog = function (jsonChromogenCatalog) {
    var chromogen = {
        chromogens: jsonChromogenCatalog.chromogens,
        chromogenBuffers: jsonChromogenCatalog.chromogenBuffers,
    };
    return chromogen;
};
export var deserializeManualProBufferCatalog = function (jsonBuffCatalog) {
    var buffer = new ManualProBufferCatalog(jsonBuffCatalog.sampleTypes, jsonBuffCatalog.defaultSampleType, extractBufferMetadata(jsonBuffCatalog.hybridization), extractBufferMetadata(jsonBuffCatalog.probeWash), extractBufferMetadata(jsonBuffCatalog.ampWash));
    return buffer;
};
export var extractBufferMetadata = function (jbm) {
    return {
        volumeMls: jbm.volumeMls.map(function (v) { return new LiquidVolume(v); }),
        defaultVolumeMl: new LiquidVolume(jbm.defaultVolumeMl)
    };
};
export var getFishAmplifierCatalog = function (legacy, catalog) {
    return legacy ? catalog.legacyFishAmplifier : catalog.goldFishAmplifier;
};
// tslint:disable-next-line:max-classes-per-file
var ProAmplifierConfig = /** @class */ (function () {
    function ProAmplifierConfig(id, label, platformCompatibility, channelNum, amplifier, hapten, enzyme, isDefault) {
        this.id = id;
        this.label = label;
        this.platformCompatibility = platformCompatibility;
        this.amplifier = amplifier;
        this.hapten = hapten;
        this.enzyme = enzyme;
        this.channelNum = channelNum;
        this.isDefault = isDefault;
    }
    return ProAmplifierConfig;
}());
export { ProAmplifierConfig };
var AutomatedProProbeSetScale = /** @class */ (function () {
    function AutomatedProProbeSetScale(pmol, volume, labelA, labelB, detailA, detailB) {
        this.pmol = pmol;
        this.volume = volume;
        this.labelA = labelA;
        this.labelB = labelB;
        this.detailA = detailA;
        this.detailB = detailB;
    }
    return AutomatedProProbeSetScale;
}());
export { AutomatedProProbeSetScale };
// tslint:disable-next-line:max-classes-per-file
var LibraryOrganism = /** @class */ (function () {
    function LibraryOrganism(id, name, scientificName, probeSetFamiliesCreator, taxonomyId) {
        this.id = id;
        this.name = name;
        this.scientificName = scientificName;
        this.probeSetFamilies = probeSetFamiliesCreator(this);
        this.taxonomyId = taxonomyId;
    }
    return LibraryOrganism;
}());
export { LibraryOrganism };
// tslint:disable-next-line:max-classes-per-file
var ProbeSetFamily = /** @class */ (function () {
    function ProbeSetFamily(id, geneSymbol, description, geneType, accessions, synonyms, variantsCreator, defaultVariantCreator) {
        this.id = id;
        this.geneSymbol = geneSymbol;
        this.description = description;
        this.geneType = geneType;
        this.variants = variantsCreator(this);
        this.defaultVariant = defaultVariantCreator(this);
        this.accessions = accessions;
        this.synonyms = synonyms;
    }
    return ProbeSetFamily;
}());
export { ProbeSetFamily };
// tslint:disable-next-line:max-classes-per-file
var Variant = /** @class */ (function () {
    function Variant(id, organism, probeSetFamily, name, designNumber, targetMrnaSeq, bindingSites, probeSetSize, validated, designType, accession, dcvScore) {
        this.id = id;
        this.organism = organism;
        this.probeSetFamily = probeSetFamily;
        this.name = name;
        this.designNumber = designNumber;
        this.targetMrnaSeq = targetMrnaSeq;
        this.bindingSites = bindingSites;
        this.accession = accession;
        this.probeSetSize = probeSetSize;
        this.validated = validated;
        this.dcvScore = dcvScore;
        this.designType = designType;
    }
    return Variant;
}());
export { Variant };
var BindingSite = /** @class */ (function () {
    function BindingSite(id, rnaVariantId, siteNumber, startPos, endPos, onTargetFrac, bindingSiteSeq, oddSite, evenSite, probeSeq, oddProbe, evenProbe, createdAt) {
        this.id = id;
        this.rnaVariantId = rnaVariantId;
        this.siteNumber = siteNumber;
        this.startPos = startPos;
        this.endPos = endPos;
        this.onTargetFrac = onTargetFrac;
        this.bindingSiteSeq = bindingSiteSeq;
        this.oddSite = oddSite;
        this.evenSite = evenSite;
        this.probeSeq = probeSeq;
        this.oddProbe = oddProbe;
        this.evenProbe = evenProbe;
        this.createdAt = createdAt;
    }
    return BindingSite;
}());
export { BindingSite };
var Accession = /** @class */ (function () {
    function Accession(id, transcriptAccession, accessionType, transcriptLength, transcriptName) {
        this.id = id;
        this.transcriptAccession = transcriptAccession;
        this.transcriptName = transcriptName;
        this.transcriptLength = transcriptLength;
        this.accessionType = accessionType;
    }
    return Accession;
}());
export { Accession };
var PredefinedLabels = /** @class */ (function () {
    function PredefinedLabels(standard, extended, admin) {
        this.standard = standard;
        this.extended = extended;
        this.admin = admin;
        this.combined = standard.concat(extended);
    }
    return PredefinedLabels;
}());
export { PredefinedLabels };
var HcrAmplifier = /** @class */ (function () {
    // it seems they all have id == name for now
    function HcrAmplifier(id) {
        this.id = id;
    }
    return HcrAmplifier;
}());
export { HcrAmplifier };
var PredefinedLabel = /** @class */ (function () {
    function PredefinedLabel(id, name, isStandard) {
        this.id = id;
        this.name = name;
        this.isStandard = isStandard;
    }
    return PredefinedLabel;
}());
export { PredefinedLabel };
/**
 * Amp:
 *  3 uM * 50 ul = 150 pmol
 *  3 uM * 200 ul = 600 pmol
 */
// tslint:disable-next-line:max-classes-per-file
var Pmol = /** @class */ (function () {
    function Pmol(value) {
        this.valuePmol = value;
        this.ampConcentratedWithUnit = value / 3 + " \u00B5L";
        if (value >= 1000) {
            this.valueWithUnit = value / 1000 + " nmol";
        }
        else {
            this.valueWithUnit = value + " pmol";
        }
    }
    return Pmol;
}());
export { Pmol };
/**
 * A probe set scale option for the scale dropdown. scaleValue is what the user picked
 * (µL on gold, pmol on v3.0 legacy — 1:1 either way at selection time). Pmol on 2GEN
 * gold kits is backend-derived from scaleValue + target design type, so form state
 * never stores it; the full ProbeSetScale (with pmol) only exists after deserialization.
 */
// tslint:disable-next-line:max-classes-per-file
var Scale = /** @class */ (function () {
    function Scale(scaleValue) {
        this.scaleValue = scaleValue;
        this.scaleWithUnits = scaleValue + " \u00B5L";
        if (scaleValue >= 1000) {
            this.pmolWithUnits = scaleValue / 1000 + " nmol";
        }
        else {
            this.pmolWithUnits = scaleValue + " pmol";
        }
    }
    return Scale;
}());
export { Scale };
// tslint:disable-next-line:max-classes-per-file
var GoldFishBufferCatalog = /** @class */ (function () {
    function GoldFishBufferCatalog(sampleTypes, defaultSampleType, goldWash, amplifier, hybridization, goldAmpWash, proAmpWash) {
        this.goldWash = goldWash;
        this.amplifier = amplifier;
        this.defaultSampleType = defaultSampleType;
        this.hybridization = hybridization;
        this.sampleTypes = sampleTypes;
        this.goldAmpWash = goldAmpWash;
        this.proAmpWash = proAmpWash;
    }
    return GoldFishBufferCatalog;
}());
export { GoldFishBufferCatalog };
// tslint:disable-next-line:max-classes-per-file
var LegacyFishBufferCatalog = /** @class */ (function () {
    function LegacyFishBufferCatalog(sampleTypes, defaultSampleType, wash, amplifier, hybridization) {
        this.wash = wash;
        this.amplifier = amplifier;
        this.defaultSampleType = defaultSampleType;
        this.hybridization = hybridization;
        this.sampleTypes = sampleTypes;
    }
    return LegacyFishBufferCatalog;
}());
export { LegacyFishBufferCatalog };
// tslint:disable-next-line:max-classes-per-file
var ManualProBufferCatalog = /** @class */ (function () {
    function ManualProBufferCatalog(sampleTypes, defaultSampleType, hybridization, probeWash, ampWash) {
        this.sampleTypes = sampleTypes;
        this.defaultSampleType = defaultSampleType;
        this.hybridization = hybridization;
        this.probeWash = probeWash;
        this.ampWash = ampWash;
    }
    return ManualProBufferCatalog;
}());
export { ManualProBufferCatalog };
// tslint:disable-next-line:max-classes-per-file
var LiquidVolume = /** @class */ (function () {
    function LiquidVolume(valueMl) {
        this.valueMl = valueMl;
        if (valueMl >= 1000) {
            this.valueWithUnit = valueMl / 1000 + " L";
        }
        else {
            this.valueWithUnit = valueMl + " mL";
        }
    }
    return LiquidVolume;
}());
export { LiquidVolume };
export var TargetDesignType;
(function (TargetDesignType) {
    TargetDesignType["STANDARD"] = "STANDARD";
    TargetDesignType["SHORT_TARGET"] = "SHORT_TARGET";
    TargetDesignType["TWO_GEN"] = "TWO_GEN";
})(TargetDesignType || (TargetDesignType = {}));
// tslint:disable-next-line:max-classes-per-file
var ProProbeDiluentScale = /** @class */ (function () {
    function ProProbeDiluentScale(volume, labelA, labelB, detail) {
        this.volume = volume;
        this.labelA = labelA;
        this.labelB = labelB;
        this.detail = detail;
    }
    return ProProbeDiluentScale;
}());
export { ProProbeDiluentScale };
// tslint:disable-next-line:max-classes-per-file
var Hapten = /** @class */ (function () {
    function Hapten(id) {
        this.id = id;
        this.name = id;
    }
    return Hapten;
}());
export { Hapten };
export var EnzymeEnum;
(function (EnzymeEnum) {
    EnzymeEnum["AP"] = "AP";
    EnzymeEnum["HRP"] = "HRP";
    EnzymeEnum["HRP_AP"] = "HRP_AP";
})(EnzymeEnum || (EnzymeEnum = {}));
export var isConsumerCatalog = function (b) {
    return b._type === 'consumer';
};
var isLegacyBufferCatalog = function (b) {
    return b._bufferType === 'legacy';
};
export var fetchRnaCatalog = function (mode, catalogType, orderId, product) {
    var path;
    var productPath = '';
    if (product != null) {
        productPath = "?product=" + product;
    }
    switch (mode) {
        case CatalogMode.Consumer:
            switch (catalogType) {
                case RelevantCatalogType.Initial:
                    path = '/order/initial/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Cart:
                    path = '/order/cart/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Orders:
                    path = "/order/orders/catalog/rna/order/" + encodeURIComponent(orderId) + productPath;
                    break;
            }
            break;
        case CatalogMode.Internal:
            switch (catalogType) {
                case RelevantCatalogType.Initial:
                    path = '/admin/initial/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Cart:
                    path = '/admin/cart/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Orders:
                    path = "/admin/orders/catalog/rna/order/" + encodeURIComponent(orderId) + productPath;
                    break;
            }
            break;
    }
    return getWithAuthn(path)
        .then(function (resp) {
        // TODO Check for 200
        return resp.json();
    })
        .then(function (jsonCatalog) {
        if (mode === CatalogMode.Consumer) {
            return deserializeUserCatalog(jsonCatalog);
        }
        else {
            return deserializeAdminCatalog(jsonCatalog);
        }
    });
};
// tslint:disable-next-line:max-classes-per-file
var MicroliterVolume = /** @class */ (function () {
    function MicroliterVolume(valueUl) {
        this.valueUl = valueUl;
        if (valueUl >= 1000) {
            this.valueWithUnit = valueUl / 1000 + " mL";
        }
        else {
            this.valueWithUnit = valueUl + " \u00B5L";
        }
    }
    return MicroliterVolume;
}());
export { MicroliterVolume };
export var RelevantCatalogType;
(function (RelevantCatalogType) {
    RelevantCatalogType[RelevantCatalogType["Initial"] = 0] = "Initial";
    RelevantCatalogType[RelevantCatalogType["Cart"] = 1] = "Cart";
    RelevantCatalogType[RelevantCatalogType["Orders"] = 2] = "Orders";
})(RelevantCatalogType || (RelevantCatalogType = {}));
//# sourceMappingURL=RnaCatalog.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/RnaCatalog.js
// module id = 10
// module chunks = 0